import {
	AdminRight,
	Role,
	UserRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export function canUserModifyRights(
	user: string,
	roles: Role[],
	users: UserRights[]
): boolean {
	const userRoles = users.find(u => u.user === user)?.roles;
	if (userRoles === undefined || userRoles.length === 0) {
		return false;
	}

	return roles
		.filter(role => userRoles.includes(role.name))
		.some(role => role.adminRights[AdminRight.RIGHTS] === true);
}
